let Utils = $.klass({
	getOption: function(value, label, disabled) {
		return $('<option/>', {value: value, html: label, disabled: !!disabled});
	},

	indent1: '&nbsp;&nbsp;&nbsp;&#8627;&nbsp;',
	indent2: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#8627;&nbsp;',

	addDropdownQuestion3D: function(survey, select, question, config) {
		if (config.showRowsAndColumns) {
			select.append($('<option/>', {
				html: this.indent1 + gettext('Rows'),
				disabled: true
			}));

			for (var i = 0; i < question.rows.length; i++) {
				var row = question.rows[i];

				select.append($('<option/>', {
					html: this.indent2 + (row.label || interpolate(gettext('Row %s'), [i + 1])),
					value: row.id
				}));
			}

			select.append($('<option/>', {
				html: this.indent1 + gettext('Columns'),
				disabled: true
			}));

			for (var i = 0; i < question.types.length; i++) {
				var col = question.types[i];

				select.append($('<option/>', {
					html: this.indent2 + (col.label || interpolate(gettext('Column %s'), [i + 1])),
					value: col.id
				}));
			}

			select.append($('<option/>', {
				html: this.indent1 + gettext('Variables'),
				disabled: true
			}));

			for (var i = 0; i < question.vars.length; i++) {
				var variable = survey.variables[question.vars[i]];

				select.append($('<option/>', {
					html: this.indent2 + variable.label,
					value: variable.id
				}));
			}

			return true;
		}
		for (var k = 0; k < question.types.length; k++) {
			var col = question.types[k];
			if (config.varFilter(col)) {
				select.append($('<option/>', {html: this.indent1 + (col.label || interpolate(gettext('Column %s'), [k+1])), disabled: !config.grouping, value: question.id + "#" + k}));
				for (var l = 0; l < question.rows.length; l++) {
					var row = question.rows[l];
					select.append($('<option/>', {
						value: row.items[k],
						html: this.indent2 + (survey.variables[row.items[k]] ? survey.variables[row.items[k]].label : '')
					}));
				}
			}
		}

		return true;
	},

	addDropdownQuestion: function(survey, select, question, config) {
		if (question.vars.length < 1) {
			if (!config.showEmpty) {
				return false;
			}

			$('<option/>', {value: question.id, html: question.label}).appendTo(select);

			return true;
		}
		
		if (question.vars.length == 1 && question.vars[0] === question.id) {
			if (!config.questionFilter(question))
				return false;

			var variable = survey.variables[question.vars[0]];

			if (!config.varFilter(variable))
				return false;

			$('<option/>', {value: question.vars[0], html: variable.label}).appendTo(select);

			return true;
		}

		var empty = true;
		var disabled = !config.questionFilter(question);
		var group = $('<option/>', {value: question.id, html: question.label}).appendTo(select);

		if (question.rows && question.rows.length > 1 && question.types && question.types.length > 1 || question.type == 'threed-grid') {
			empty = !this.addDropdownQuestion3D(survey, select, question, config);
		} else {
			for (var k = 0; k < question.vars.length; k++) {
				var variable = survey.variables[question.vars[k]];

				if (config.varFilter(variable)) {
					select.append($('<option/>', {value: question.vars[k], html: this.indent1 + variable.label}));
					empty = false;
				}
			}
		}

		if (empty && disabled) {
			group.remove();
			return false;
		}

		if (disabled) {
			group.attr('disabled', true);
		}

		return true;
	},

	addDropdownPage: function(survey, select, page, config) {
		var group = $('<optgroup/>', {label: page.page});
		var empty = true;
		for (var i = 0; i < page.questions.length; i++) {
			if (this.addDropdownQuestion(survey, group, survey.questions[page.questions[i]], config)) {
				empty = false;
			}
		}

		if (!empty) {
			select.append(group);
		}
	},

	buildSourceDropdown: function(survey, config) {
		config = $.extend({}, config || {}, {
			varFilter: ($.isFunction(config.varPred)) ? config.varPred : function() { return !!config.varPred; },
			questionFilter: ($.isFunction(config.questionPred)) ? config.questionPred : function() { return !!config.questionPred; },
			pageFilter: ($.isFunction(config.pagePred)) ? config.pagePred : function() { return (config.pagePred === undefined) ? true : !!config.pagePred; }
		});
		
		var select = $('<select class="custom-select"/>');
		
		if (config.multiple) {
			select.attr('multiple','multiple');
		} else {
			select.append($('<option/>', {value: '-', html: gettext('Please select a question or variable...')}));
		}
		
		if (!!config.showMetas && !FS_EMBEDDED) {
			var metaGroup = $('<optgroup/>', {
				label: gettext('Response Variables')
			}).appendTo(select);

			for (var i = 0; i < survey.metas.length; i++) {
				var variable = survey.variables[survey.metas[i]];
				if (config.varFilter(variable)) {
					metaGroup.append($('<option/>', {
						value: survey.metas[i],
						html: variable.label
					}));
				}
			}
			if (survey.variables['_gv']){
				metaGroup.append($('<option/>', {
					value: survey.variables['_gv'].id,
					html: survey.variables['_gv'].label
				}));
			}
		}
		if (survey.collector_variables && survey.collector_variables.length>0){
			var collectorGroup = $('<optgroup/>', {
					label: gettext('Collector Variables')
				}).appendTo(select);

				for (var i = 0; i < survey.collector_variables.length; i++) {
					collectorGroup.append($('<option/>', {
						value: '_cv_'+ survey.collector_variables[i],
						html: survey.variables['_cv_'+ survey.collector_variables[i]].label
					}));
				}
				
		}

		for (var i = 0; i < survey.pages.length; i++) {
			if (config.pageFilter(survey.pages[i])) {
				this.addDropdownPage(survey, select, survey.pages[i], config);
			}
		}

		return select;
	}
});

module.exports = Utils;
